










































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import AdminService from '@/api/AdminService';
import { treatError } from '@/utils/index';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class RevokeInvitationConfirmModal extends Vue {
  @Prop(String) readonly inviteId!: string;
  service = new AdminService();
  loading: boolean = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  async revokeOwnershipTransfer() {
    try {
      this.loading = true;
      await this.service.deleteManagerInvite(this.inviteId);

      this.$notification('Ownership successfully revoked');
      eventBus.$emit('reloadBusinessOwnershipList');
      eventBus.$emit('closeModal');
    } catch (res) {
      this.$notification(treatError(res));
    } finally {
      this.loading = false;
    }
  }
}
